(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.skafe-announcement__video').forEach((video) => {
    const connection = navigator.connection;
    const constrained = connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
    if (constrained || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
    video.play().catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const THRESHOLD = 6;
    const SKIP = 'button, input, textarea, select, label, .quick-add, .slider-buttons';

    const bindCarousel = (root) => {
      if (root.dataset.skafeCarouselBound === 'true') return;
      root.dataset.skafeCarouselBound = 'true';

      const track = root.querySelector('[id^="Slider-"]');
      if (!track) return;

      const autoplayButton = root.querySelector('.skafe-featured-autoplay');
      const labelPause = autoplayButton?.dataset.labelPause || 'Pause';
      const labelPlay = autoplayButton?.dataset.labelPlay || 'Play';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const wantsAutoplay = root.dataset.skafeAutoplay === 'true' && !reducedMotion.matches;
      const speed = Math.max(4, Number(root.dataset.skafeAutoplaySpeed) || 6) * 1000;

      let drag = null;
      let timer = null;
      let userPaused = false;
      let hoverPaused = false;
      let focusPaused = false;
      let dragPaused = false;
      let visible = true;

      const canScroll = () => track.scrollWidth > track.clientWidth + 2;

      const slideOffset = () => {
        const slides = Array.from(track.querySelectorAll('.slider__slide')).filter((el) => el.clientWidth > 0);
        if (slides.length < 2) return Math.max(track.clientWidth * 0.8, 1);
        return slides[1].offsetLeft - slides[0].offsetLeft;
      };

      const advance = () => {
        if (!canScroll()) return;
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= maxScroll - 4) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        track.scrollTo({ left: track.scrollLeft + slideOffset(), behavior: 'smooth' });
      };

      const stopTimer = () => {
        clearInterval(timer);
        timer = null;
      };

      const softPaused = () => hoverPaused || focusPaused || dragPaused;

      const startTimer = () => {
        stopTimer();
        if (!wantsAutoplay || userPaused || softPaused() || !visible || !canScroll()) return;
        track.setAttribute('aria-live', 'off');
        timer = setInterval(advance, speed);
      };

      const syncPlayback = () => {
        if (userPaused || softPaused() || !visible) {
          track.setAttribute('aria-live', 'polite');
          stopTimer();
          return;
        }
        startTimer();
      };

      const setUserPaused = (paused) => {
        userPaused = paused;
        if (!autoplayButton) return;
        autoplayButton.classList.toggle('skafe-featured-autoplay--paused', paused);
        autoplayButton.setAttribute('aria-label', paused ? labelPlay : labelPause);
        syncPlayback();
      };

      if (autoplayButton) {
        autoplayButton.addEventListener('click', () => setUserPaused(!userPaused));
      }

      if (wantsAutoplay) {
        root.addEventListener('mouseenter', () => {
          hoverPaused = true;
          syncPlayback();
        });
        root.addEventListener('mouseleave', () => {
          hoverPaused = false;
          syncPlayback();
        });
        root.addEventListener('focusin', () => {
          focusPaused = true;
          syncPlayback();
        });
        root.addEventListener('focusout', (event) => {
          if (root.contains(event.relatedTarget)) return;
          focusPaused = false;
          syncPlayback();
        });

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(
            ([entry]) => {
              visible = entry.isIntersecting;
              syncPlayback();
            },
            { threshold: 0.35 }
          );
          observer.observe(root);
        }

        syncPlayback();
      }

      const endDrag = (event) => {
        if (!drag || (event && drag.id !== event.pointerId)) return;
        const moved = drag.moved;
        const dx = drag.dx || 0;
        const id = drag.id;
        drag = null;
        root.classList.remove('is-dragging');
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', onUp);
        document.removeEventListener('pointercancel', onUp);
        if (track.hasPointerCapture?.(id)) {
          try {
            track.releasePointerCapture(id);
          } catch (_) {}
        }
        dragPaused = false;
        syncPlayback();
        if (!moved || Math.abs(dx) < THRESHOLD) return;
        const blockClick = (clickEvent) => {
          clickEvent.preventDefault();
          clickEvent.stopPropagation();
          track.removeEventListener('click', blockClick, true);
        };
        track.addEventListener('click', blockClick, true);
      };

      const onMove = (event) => {
        if (!drag || drag.id !== event.pointerId) return;
        const dx = event.clientX - drag.x;
        drag.dx = dx;
        if (!drag.moved) {
          if (Math.abs(dx) < THRESHOLD) return;
          drag.moved = true;
          // Capture only once it is a real drag: capturing on pointerdown
          // retargets the click to the track and the card link never fires.
          try {
            track.setPointerCapture(event.pointerId);
          } catch (_) {}
          root.classList.add('is-dragging');
          dragPaused = true;
          syncPlayback();
        }
        event.preventDefault();
        track.scrollLeft = drag.scroll - dx;
      };

      const onUp = (event) => endDrag(event);

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.button > 0) return;
        if (event.target.closest(SKIP)) return;
        if (!canScroll()) return;
        if (drag) endDrag();
        drag = {
          id: event.pointerId,
          x: event.clientX,
          scroll: track.scrollLeft,
          moved: false,
        };
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
        document.addEventListener('pointercancel', onUp);
      });

      track.addEventListener('dragstart', (event) => event.preventDefault());

      if (wantsAutoplay) {
        track.addEventListener(
          'touchstart',
          () => {
            dragPaused = true;
            syncPlayback();
          },
          { passive: true }
        );
        track.addEventListener('touchend', () => {
          dragPaused = false;
          syncPlayback();
        });
        if ('ResizeObserver' in window) {
          new ResizeObserver(() => syncPlayback()).observe(track);
        }
        window.addEventListener('load', syncPlayback, { once: true });
      }
    };

    const init = () => {
      document.querySelectorAll('.skafe-featured-products').forEach(bindCarousel);
    };

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerHeightHandler = this.setHeaderHeight.bind(this);
      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerMediaQuery.addEventListener('change', this.headerHeightHandler);
      this.headerResizeObserver = new ResizeObserver(this.headerHeightHandler);
      this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerMediaQuery?.removeEventListener('change', this.headerHeightHandler);
      this.headerResizeObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skafe-brand-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('skafe-brands-rail')) {
    customElements.define(
      'skafe-brands-rail',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-skafe-brands-track]');
          this.progress = this.querySelector('[data-skafe-brands-progress]');
          this.scrub = this.querySelector('[data-skafe-brands-scrub]');
          this.thumb = this.querySelector('[data-skafe-brands-thumb]');
          if (!this.track || !this.progress || !this.scrub || !this.thumb) return;

          this.onScroll = () => {
            if (this.ticking) return;
            this.ticking = true;
            requestAnimationFrame(() => {
              this.ticking = false;
              this.sync();
            });
          };

          this.onWheel = (event) => {
            if (!this.classList.contains('is-overflow')) return;
            if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
            this.track.scrollLeft += event.deltaY;
            event.preventDefault();
          };

          this.endTrackDrag = (event) => {
            if (!this.drag || (event && this.drag.id !== event.pointerId)) return;
            const moved = this.drag.moved;
            const id = this.drag.id;
            this.drag = null;
            this.classList.remove('is-dragging');
            document.removeEventListener('pointermove', this.onTrackPointerMove);
            document.removeEventListener('pointerup', this.onTrackPointerUp);
            document.removeEventListener('pointercancel', this.onTrackPointerUp);
            if (this.track.hasPointerCapture?.(id)) {
              try {
                this.track.releasePointerCapture(id);
              } catch (_) {}
            }
            if (moved) {
              const blockClick = (clickEvent) => {
                clickEvent.preventDefault();
                clickEvent.stopPropagation();
                this.track.removeEventListener('click', blockClick, true);
              };
              this.track.addEventListener('click', blockClick, true);
            }
          };

          this.onTrackPointerDown = (event) => {
            if (event.pointerType === 'touch' || event.button > 0) return;
            if (!this.classList.contains('is-overflow')) return;
            if (this.drag) this.endTrackDrag();
            this.drag = {
              id: event.pointerId,
              x: event.clientX,
              scroll: this.track.scrollLeft,
              moved: false,
            };
            document.addEventListener('pointermove', this.onTrackPointerMove);
            document.addEventListener('pointerup', this.onTrackPointerUp);
            document.addEventListener('pointercancel', this.onTrackPointerUp);
          };

          this.onTrackPointerMove = (event) => {
            if (!this.drag || this.drag.id !== event.pointerId) return;
            const dx = event.clientX - this.drag.x;
            if (!this.drag.moved) {
              if (Math.abs(dx) < 6) return;
              this.drag.moved = true;
              try {
                this.track.setPointerCapture(event.pointerId);
              } catch (_) {}
              this.classList.add('is-dragging');
            }
            event.preventDefault();
            this.track.scrollLeft = this.drag.scroll - dx;
          };

          this.onTrackPointerUp = (event) => {
            this.endTrackDrag(event);
          };

          this.onTrackDragStart = (event) => {
            event.preventDefault();
          };

          this.onScrubPointerDown = (event) => {
            if (event.button > 0) return;
            this.classList.add('is-scrubbing');
            this.scrubScroll(event.clientX);
            this.scrub.setPointerCapture(event.pointerId);
          };

          this.onScrubPointerMove = (event) => {
            if (!this.classList.contains('is-scrubbing')) return;
            this.scrubScroll(event.clientX);
          };

          this.onScrubPointerUp = () => {
            this.classList.remove('is-scrubbing');
          };

          this.onProgressKeyDown = (event) => {
            const max = this.track.scrollWidth - this.track.clientWidth;
            if (max <= 0) return;
            const step = Math.max(48, this.track.clientWidth * 0.35);
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
              this.track.scrollLeft = Math.min(max, this.track.scrollLeft + step);
              event.preventDefault();
            } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
              this.track.scrollLeft = Math.max(0, this.track.scrollLeft - step);
              event.preventDefault();
            } else if (event.key === 'Home') {
              this.track.scrollLeft = 0;
              event.preventDefault();
            } else if (event.key === 'End') {
              this.track.scrollLeft = max;
              event.preventDefault();
            }
          };

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('wheel', this.onWheel, { passive: false });
          this.track.addEventListener('pointerdown', this.onTrackPointerDown);
          this.track.addEventListener('dragstart', this.onTrackDragStart);
          this.scrub.addEventListener('pointerdown', this.onScrubPointerDown);
          this.scrub.addEventListener('pointermove', this.onScrubPointerMove);
          this.scrub.addEventListener('pointerup', this.onScrubPointerUp);
          this.scrub.addEventListener('pointercancel', this.onScrubPointerUp);
          this.progress.addEventListener('keydown', this.onProgressKeyDown);
          this.ro = new ResizeObserver(() => this.sync());
          this.ro.observe(this.track);
          this.sync();
        }

        disconnectedCallback() {
          this.endTrackDrag?.();
          this.track?.removeEventListener('scroll', this.onScroll);
          this.track?.removeEventListener('wheel', this.onWheel);
          this.track?.removeEventListener('pointerdown', this.onTrackPointerDown);
          this.track?.removeEventListener('dragstart', this.onTrackDragStart);
          this.scrub?.removeEventListener('pointerdown', this.onScrubPointerDown);
          this.scrub?.removeEventListener('pointermove', this.onScrubPointerMove);
          this.scrub?.removeEventListener('pointerup', this.onScrubPointerUp);
          this.scrub?.removeEventListener('pointercancel', this.onScrubPointerUp);
          this.progress?.removeEventListener('keydown', this.onProgressKeyDown);
          this.ro?.disconnect();
        }

        scrubScroll(clientX) {
          const rect = this.scrub.getBoundingClientRect();
          const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.track.scrollLeft = ratio * max;
        }

        sync() {
          const { scrollLeft, scrollWidth, clientWidth } = this.track;
          const max = scrollWidth - clientWidth;
          const overflow = max > 2;
          this.classList.toggle('is-overflow', overflow);
          this.classList.toggle('is-at-start', !overflow || scrollLeft <= 2);
          this.classList.toggle('is-at-end', !overflow || scrollLeft >= max - 2);
          this.progress.hidden = !overflow;
          if (!overflow) return;

          const ratio = Math.min(1, clientWidth / scrollWidth);
          const thumbW = Math.max(18, ratio * 100);
          const travel = this.scrub.clientWidth * (1 - thumbW / 100);
          const x = max > 0 ? (scrollLeft / max) * travel : 0;
          this.style.setProperty('--skafe-brands-thumb-w', `${thumbW}%`);
          this.style.setProperty('--skafe-brands-thumb-x', `${x}px`);
          this.progress.setAttribute('aria-valuenow', String(Math.round((scrollLeft / max) * 100)));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skafe-campaign"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.skafe-promo').forEach((promo) => {
    const connection = navigator.connection;
    const constrained = connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
    if (constrained || promo.dataset.skafeAutoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const mobile = promo.querySelector('[data-skafe-video="mobile"]');
    const desktop = promo.querySelector('[data-skafe-video="desktop"]');
    const target = window.matchMedia('(max-width: 749px)').matches && mobile ? mobile : desktop;
    if (!target) return;

    target.addEventListener('playing', () => target.classList.add('is-playing'), { once: true });
    target.load();
    target.play().catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skafe-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('skafe-reels')) {
    customElements.define(
      'skafe-reels',
      class extends HTMLElement {
        constructor() {
          super();
          this.fullscreenHandler = () => this.updateFullscreenLabels();
        }

        connectedCallback() {
          if (!this.dataset.reelsReady) {
            this.dataset.reelsReady = 'true';
            this.addEventListener('click', this.handleClick);
            this.addEventListener('input', this.handleInput);
          }
          this.ownerDocument.addEventListener('fullscreenchange', this.fullscreenHandler);
        }

        disconnectedCallback() {
          this.ownerDocument.removeEventListener('fullscreenchange', this.fullscreenHandler);
        }

        handleClick(event) {
          const button = event.target.closest('[data-reels-start], [data-reels-toggle], [data-reels-mute], [data-reels-fullscreen]');
          if (!button || !this.contains(button)) return;
          const card = button.closest('[data-reels-card]');
          const video = card.querySelector('video');

          if (button.hasAttribute('data-reels-start')) {
            this.startVideo(card);
            return;
          }

          if (!video) return;
          if (button.hasAttribute('data-reels-toggle')) {
            if (video.paused) video.play().catch(() => {});
            else video.pause();
          } else if (button.hasAttribute('data-reels-mute')) {
            video.muted = !video.muted;
            this.updateCard(card, video);
          } else if (button.hasAttribute('data-reels-fullscreen')) {
            const player = card.querySelector('[data-reels-player]');
            if (this.ownerDocument.fullscreenElement === player) this.ownerDocument.exitFullscreen();
            else if (player.requestFullscreen) player.requestFullscreen();
          }
        }

        handleInput(event) {
          const progress = event.target.closest('[data-reels-progress]');
          if (!progress || !this.contains(progress)) return;
          const video = progress.closest('[data-reels-card]').querySelector('video');
          if (video && Number.isFinite(video.duration) && video.duration > 0) {
            video.currentTime = (Number(progress.value) / 100) * video.duration;
          }
        }

        startVideo(card) {
          const template = card.querySelector('template[data-reels-video]');
          const media = card.querySelector('[data-reels-media]');
          if (!template || !media) return;

          let video = card.querySelector('video');
          if (!video) {
            video = template.content.querySelector('video').cloneNode(true);
            media.replaceChildren(video);
            card.querySelector('[data-reels-start]').hidden = true;
            card.querySelector('[data-reels-controls]').hidden = false;
            video.addEventListener('loadedmetadata', () => this.updateCard(card, video));
            video.addEventListener('timeupdate', () => this.updateCard(card, video));
            video.addEventListener('play', () => {
              this.ownerDocument.querySelectorAll('skafe-reels video').forEach((otherVideo) => {
                if (otherVideo !== video) otherVideo.pause();
              });
              this.updateCard(card, video);
            });
            video.addEventListener('pause', () => this.updateCard(card, video));
            video.addEventListener('volumechange', () => this.updateCard(card, video));
            video.addEventListener('ended', () => this.updateCard(card, video));
          }

          video.play().catch(() => this.updateCard(card, video));
        }

        updateCard(card, video) {
          const toggle = card.querySelector('[data-reels-toggle]');
          const playIcon = toggle.querySelector('[data-reels-icon-play]');
          const pauseIcon = toggle.querySelector('[data-reels-icon-pause]');
          const mute = card.querySelector('[data-reels-mute]');
          const progress = card.querySelector('[data-reels-progress]');
          const time = card.querySelector('[data-reels-time]');
          const duration = Number.isFinite(video.duration) ? video.duration : 0;
          const formatTime = (seconds) => {
            const whole = Math.max(0, Math.floor(seconds || 0));
            return Math.floor(whole / 60) + ':' + String(whole % 60).padStart(2, '0');
          };

          playIcon.hidden = !video.paused;
          pauseIcon.hidden = video.paused;
          toggle.setAttribute('aria-label', video.paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
          mute.setAttribute('aria-label', video.muted ? mute.dataset.labelMuted : mute.dataset.labelUnmuted);
          mute.setAttribute('aria-pressed', String(video.muted));
          time.textContent = formatTime(video.currentTime) + ' / ' + formatTime(duration);
          progress.disabled = duration === 0;
          progress.value = duration ? String((video.currentTime / duration) * 100) : '0';
          progress.setAttribute('aria-valuetext', formatTime(video.currentTime));
          this.updateFullscreenLabels();
        }

        updateFullscreenLabels() {
          this.querySelectorAll('[data-reels-fullscreen]').forEach((button) => {
            const player = button.closest('[data-reels-player]');
            const isFullscreen = this.ownerDocument.fullscreenElement === player;
            button.setAttribute('aria-label', isFullscreen ? button.dataset.labelExit : button.dataset.labelEnter);
            button.hidden = !player.requestFullscreen;
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
